import PropTypes from 'prop-types';
import { useState } from 'react';
import { Button, FormControlLabel, MenuItem, Stack, Switch, TextField } from '@mui/material';
import { useOrderActions } from 'src/context/providers/OrderContext';
import { PHYSICAL_STATUSES } from './view/data';

const BulkStatusAction = ({ scope, label }) => {
  const { changePhysicalStatuses } = useOrderActions();
  const [status, setStatus] = useState('');
  const [saving, setSaving] = useState(false);
  const [manual, setManual] = useState(false);
  const [comment, setComment] = useState('');

  const handleMove = async () => {
    setSaving(true);
    const manualFields = manual ? { manual: true, comment: comment.trim() } : {};
    const moved = await changePhysicalStatuses({ ...scope, status, ...manualFields }).catch(
      () => null
    );
    if (moved) {
      setStatus('');
      setComment('');
    }
    setSaving(false);
  };

  return (
    <Stack spacing={1} sx={{ width: '96%', my: 1 }}>
    <Stack direction="row" spacing={1} alignItems="center">
      <TextField
        select
        size="small"
        label={label}
        value={status}
        onChange={(event) => setStatus(event.target.value)}
        sx={{ flex: 1 }}
      >
        {PHYSICAL_STATUSES.map((value) => (
          <MenuItem key={value} value={value}>
            {value}
          </MenuItem>
        ))}
      </TextField>
      <FormControlLabel
        label="Manual"
        control={<Switch checked={manual} onChange={(event) => setManual(event.target.checked)} />}
      />
      <Button
        variant="contained"
        disabled={!status || saving || (manual && !comment.trim())}
        onClick={handleMove}
      >
        Move
      </Button>
    </Stack>
    {manual && (
      <TextField
        size="small"
        label="Reason for manual status (required)"
        value={comment}
        onChange={(event) => setComment(event.target.value)}
      />
    )}
    </Stack>
  );
};

BulkStatusAction.propTypes = {
  scope: PropTypes.shape({
    pallet_id: PropTypes.string,
    airwaybill_id: PropTypes.string,
  }).isRequired,
  label: PropTypes.string,
};

BulkStatusAction.defaultProps = {
  label: 'Move all parcels to status',
};

export default BulkStatusAction;
